/**
 * Lightweight global event bus for cross-component cache invalidation.
 * Used as an equivalent to React Query's query invalidation without adding a dependency.
 */
class ApiEventsManager {
  constructor() {
    this.listeners = new Map();
  }

  subscribe(key, callback) {
    if (!this.listeners.has(key)) {
      this.listeners.set(key, new Set());
    }
    this.listeners.get(key).add(callback);
    return () => {
      this.listeners.get(key).delete(callback);
    };
  }

  emit(key) {
    const callbacks = this.listeners.get(key);
    if (callbacks) {
      (Array.isArray(callbacks) ? callbacks : []).forEach((cb) => cb());
    }
  }
}

export const apiEvents = new ApiEventsManager();
